import { createSlice } from '@reduxjs/toolkit';

const emptyList = { rows: [], total: 0, page: 1, pageSize: 25 };

const slice = createSlice({
  name: 'admin',
  initialState: {
    affiliates: { ...emptyList, summary: null },
    detail: null,
    withdrawals: { ...emptyList, summary: null },
    commissions: emptyList
  },
  reducers: {
    adminLogin: () => { },
    adminLogout: () => { },
    getAffiliates: () => { },
    getAffiliatesSuccess: (state, action) => { state.affiliates = action.payload; },
    getAffiliateDetail: () => { },
    getAffiliateDetailSuccess: (state, action) => { state.detail = action.payload; },
    clearAffiliateDetail: (state) => { state.detail = null; },
    updateAffiliateStatus: () => { },
    getWithdrawals: () => { },
    getWithdrawalsSuccess: (state, action) => { state.withdrawals = action.payload; },
    updateWithdrawal: () => { },
    getCommissions: () => { },
    getCommissionsSuccess: (state, action) => { state.commissions = action.payload; },
    adjustCommission: () => { },
    reverseCommission: () => { },
    voidReferral: () => { },
    runScan: () => { },
    exportCsv: () => { }
  }
});

export const {
  adminLogin, adminLogout, getAffiliates, getAffiliatesSuccess, getAffiliateDetail, getAffiliateDetailSuccess,
  clearAffiliateDetail, updateAffiliateStatus, getWithdrawals, getWithdrawalsSuccess, updateWithdrawal,
  getCommissions, getCommissionsSuccess, adjustCommission, reverseCommission, voidReferral, runScan, exportCsv
} = slice.actions;
export default slice.reducer;
